import { render, staticRenderFns } from "./HeroDigitalAgency.vue?vue&type=template&id=36f07088&scoped=true&"
import script from "./HeroDigitalAgency.vue?vue&type=script&lang=js&"
export * from "./HeroDigitalAgency.vue?vue&type=script&lang=js&"
import style0 from "./HeroDigitalAgency.vue?vue&type=style&index=0&id=36f07088&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f07088",
  null
  
)

export default component.exports